import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layouts";
import Home from "./pages/Home";
import "./App.css"; 
import "./index.css"; 
import "./pages.css"; 
import { cache, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getSessionTokenService,
  getAccessTokenService,
  generateAbhaSessionServices
} from "./services";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import appConfig from "./config";
// console.log("Front end server running");
import UserConsent from "./pages/terms-condition/term_condition";
import Terms_Condition from "./pages/terms-condition/term_condition";

function App() {
  const getAbhaSession = async () => {
    const response = await generateAbhaSessionServices();
    if (response.success) {
      const abhaSessionToken = response.data;
      localStorage.clear();
      localStorage.setItem("abhaSessionToken", abhaSessionToken);
      getToken();
    } else {
      console.error(
        "Failed to fetch session token:",
        response.message || response
      );
    }
  };
  const getToken = async () => {
    try {
      const headers = {
        token: appConfig.api_key
      };
      const body = {};

      const response = await getSessionTokenService({ headers, body });

      if (response.status) {
        const sessionToken = response.result;
        localStorage.setItem("sessionToken", sessionToken);
        accesstoken(sessionToken);
      } else {
        console.error(
          "Failed to fetch session token:",
          response.message || response
        );
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  const accesstoken = async (timetoken) => {
    try {
      const headers = {
        // token: process.env.REACT_APP_API_KEY
        token: appConfig.api_key
      };
      const body = {
        RequestId: timetoken
      };
      const response = await getAccessTokenService({ headers, body });
      if (response.status) {
        const authToken = response.result.token;
        localStorage.setItem("authToken", authToken);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  useEffect(() => {
    getAbhaSession();
  }, []);

  // useEffect(() => {
  //   dispatch(setLoader(true)); // Show loader
  //   setTimeout(() => {
  //     dispatch(setLoader(false)); // Hide loader after 3 seconds
  //   }, 3000);
  // }, [dispatch]);
  // const loading = useSelector((state) => {
  //   console.log("Redux State:", state); // Add this line to inspect the state
  //   return state.user.loading; // Ensure 'state.loader' exists
  // });
  const loading = useSelector((state) => state.user.loading);

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} /> {/* Default route */}
            <Route path="/terms-condition" element={<Terms_Condition />} />{" "}
            {/* Default route */}
          </Route>
        </Routes>
        <ClipLoader
          color="#36d7b7"
          loading={loading}
          size={50}
          className="loader"
        />
      </BrowserRouter>
    </>
  );
}

export default App;
